/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/
import React from 'react'
import { Routes, Route } from 'react-router-dom'


import HomePage from './public/HomePage'
import AboutPage from './public/AboutPage'
import TOSPage from './public/TOSPage'
import PrivacyPolicyPage from './public/PrivacyPolicyPage'
import ContactUsPage from './public/ContactUsPage'
import useGaTracker from './useGaTracker'
import DeletemePage from './public/DeletemePage'
import JoinPage from './public/JoinPage'


const Pages = () => {
  useGaTracker();

  return (
    <Routes>
      <Route exact path={"/"} element={
        <HomePage />
      } />
      <Route exact path={"/home"} element={
        <HomePage />
      } />
      <Route exact path={"/about"} element={
        <AboutPage />
      } />
      <Route exact path={"/tos"} element={
        <TOSPage />
      } />
      <Route exact path={"/privacypolicy"} element={
        <PrivacyPolicyPage />
      } />
      <Route exact path={"/deleteme"} element={
        <DeletemePage />
      } />
      <Route exact path={"/contact"} element={
        <ContactUsPage />
      } />
      <Route exact path={"/join"} element={
        <JoinPage />
      } />
      <Route exact path={"/viewpost"} element={
        <JoinPage />
      } />
    </Routes>


  )
}
export default Pages
